/* ==========================================================================
   theme.custom.js — theme-level custom behavior.

   Loaded AFTER theme.js + cart.js, so a theme can add interactivity WITHOUT
   editing the core files. In the overlay build a theme replaces this file with
   its own (themes/<name>/assets/theme.custom.js). Keep the CORE copy empty.

   The core component APIs are available here: theme.cart, theme.toast,
   theme.utils, the custom elements (<lumen-drawer> etc.), and the
   'variant:changed' / 'cart:updated' events.
   ========================================================================== */
(function () {
  'use strict';
  // Theme-specific code goes here (in the theme's overlay copy of this file).
})();
